import { useHistoryBatch } from 'contexts/HistoryBatch';
import { cpf } from 'cpf-cnpj-validator';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type PartialProcessedProps = {
  isDeactivate: boolean;
};

export const PartialProcessedMobile = ({ isDeactivate }: PartialProcessedProps) => {
  const { fileDetails } = useHistoryBatch();

  const navigate = useNavigate();

  const { t } = useTranslation(['history', 'beneficiaries']);

  const redirectToCreateBatch = () => {
    if (isDeactivate) {
      navigate('?m=dropdown-modal-deactivate');
      return;
    }

    navigate('?m=dropdown-modal-include');
  };

  if (!fileDetails) return null;

  return (
    <div className="error-import-mobile">
      <p>{t('details')}</p>
      <span>{t('details_subtitle')}</span>
      <hr className="divider" />
      {fileDetails.map((item) => (
        <div className="error-table-mobile" key={item.cpf}>
          <div>
            <span className="bold">CPF: </span>
            <span>{cpf.format(item.cpf)}</span>
          </div>
          <div>
            <span className="bold">Erro: </span>
            <span>{item.message}</span>
          </div>
        </div>
      ))}
      <div className="button-container">
        <button type="button" className="reimport-button" onClick={redirectToCreateBatch}>
          {t('reimport')}
        </button>
      </div>
    </div>
  );
};
